export default __webpack_public_path__ + "static/media/refresh-2.18a9976c.svg";